 
import React, { useEffect, useState } from "react";
import { Typography, Card, Button, Input, Skeleton } from "antd";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
 
import {
  
  ArrowLeftOutlined,
  FileTextOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import RCCard from "../components/RCCard";
import { backend_url } from "../LOCAL/VARIABLE";

const { Title, Paragraph } = Typography;

 
const fetchRCDetails = async (rcNumber) => {
     if (!rcNumber) {
      toast.error("RC Number (user) not provided in URL!");
      throw new Error("RC Number not provided");
    }
    const params = new URLSearchParams(window.location.search);
    const user = params.get("user");
     if (!user) {
      toast.error(" (user) not provided in URL!");
      throw new Error("  user not provided");
    }
  const res = await fetch(`${backend_url}/api/rc/${rcNumber}/${user}`); // apna backend endpoint
  if (!res.ok) {

  const errorData = await res.json().catch(() => ({
        message: "Something went wrong!",
      }));

      // Toast dikhao
      toast.error(errorData.message || "Failed to fetch RC details");
       // Error throw karo taki upar handle kar sako
      throw new Error(errorData.message || "Failed to fetch RC details");
  }
  const ss= await res.json();
  return ss
};

// ✅ Recursive renderer function
// const renderObject = (data) => {
  
// };

const RCFetch = ({refetch}) => {
  const navigate = useNavigate();
  const [rcNumber, setRCNumber] = useState("");
  const [submittedRC, setSubmittedRC] = useState("");

  const { data: rcData, isFetching , isLoading } = useQuery({
    queryKey: ["rcDetails", submittedRC],
    queryFn: () => fetchRCDetails(submittedRC),
    enabled: !!submittedRC,
    refetchOnWindowFocus: false,
    retry: false,
    onError: (d) => toast.error( d.response.data.message ||  "Failed to fetch RC details"),
    onSuccess: () => toast.success("RC details fetched successfully"),
  });


  useEffect(()=>{refetch()},[isLoading])


  const handleFetchRC = () => {
    if (!rcNumber) return toast.error("Please enter RC number");
    setSubmittedRC(rcNumber);
  };

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      {/* Header */}
      <header className="flex items-center px-4 py-3 bg-white text-black shadow-md fixed w-full z-50 h-[55px]">
        <Button
          type="text"
          icon={<ArrowLeftOutlined style={{ fontSize: 20, color: "red" }} />}
          onClick={() => navigate(-1)}
        />
        <Title level={5} className="m-0 flex-1 text-center !text-red-600">
          Fetch RC Details
        </Title>
      </header>

      {/* Content */}
      <div className="mt-[55px] flex-1 overflow-y-auto   ">
        {/* RC Input */}
      <div className="mb-4">
        <Input
          placeholder="Enter RC Number"
          value={rcNumber}
          onChange={(e) => setRCNumber(e.target.value)}
          prefix={<SearchOutlined className="text-gray-400" />}
          className="rounded-lg py-2 border-gray-300 focus:border-red-500 focus:ring-2 focus:ring-red-300"
        />
      </div>

      {/* Stylish Button with icon */}
      <Button
        type="primary"
        icon={<FileTextOutlined />}
        loading={isLoading}
        className="bg-red-500 hover:bg-red-600 rounded-lg h-11 flex items-center justify-center font-medium text-white"
        block
        onClick={handleFetchRC}
      >
        Fetch RC Details
      </Button>

        {/* RC Details */}
        <section>
          {isFetching ? (
            <Skeleton active paragraph={{ rows: 12 }} />
          ) : (
            rcData && (
            
                <RCCard   rc={rcNumber} data={rcData} />
             
            )
          )}
        </section>

      
      </div>
    </div>
  );
};

export default RCFetch;
